<script setup lang="js">
import WidthFull from "@/components/WidthFull.vue";
import Context from "@/components/Context.vue";
import TitileTwoBlack from "@/components/TitileTwo-Black.vue";
import TitileTwoWhile from "@/components/TitileTwo-While.vue";
import TextContext from "@/components/TextContext.vue";
import TitleBold from "@/components/TitleBold.vue";
import ContextColors from "@/components/ContextColors.vue";
import {onMounted, ref} from "vue";
import TextCenterContext from "@/components/TextCenterContext.vue";

const xmal = ref("https://cos5.51tgqj.com/techming/img/xmal@2x.png");
const jyIp = ref("https://cos5.51tgqj.com/techming/img/jyIP@2x.png");
const szxt = ref("https://cos5.51tgqj.com/techming/img/SZXT@2x.png");
const jyzd = ref("https://cos5.51tgqj.com/techming/img/JYZD@2x.png");
const jyhd = ref("https://cos5.51tgqj.com/techming/img/JYHD@2x.png");
const zu12336 = ref("https://cos5.51tgqj.com/techming/img/组 12325@2x.png");
const JSFN = ref("https://cos5.51tgqj.com/techming/img/JSFN@2x.png");


const SZXT = ref("https://cos5.51tgqj.com/techming/img/SZXT@2x.png");
const JYZD = ref("https://cos5.51tgqj.com/techming/img/JYZD@2x.png");
const JYHD = ref("https://cos5.51tgqj.com/techming/img/JYHD@2x.png");
const zsta = ref("https://cos5.51tgqj.com/techming/img/zsta@2x.png");
const tgbz = ref("https://cos5.51tgqj.com/techming/img/tgbz@2x.png");
const zgmbz = ref("https://cos5.51tgqj.com/techming/img/zgmbz@2x.png");
const qfzpbz = ref("https://cos5.51tgqj.com/techming/img/qfzpbz@2x.png");
const mcfbz = ref("https://cos5.51tgqj.com/techming/img/mcfbz@2x.png");
const jzjlbz = ref("https://cos5.51tgqj.com/techming/img/jzjlbz@2x.png");
const gxzaxpbz = ref("https://cos5.51tgqj.com/techming/img/gxzaxpbz@2x.png");
const lqqbz = ref("https://cos5.51tgqj.com/techming/img/lqqbz@2x.png");
const cypbz = ref("https://cos5.51tgqj.com/techming/img/cypbz@2x.png");
const wszpbz = ref("https://cos5.51tgqj.com/techming/img/wszpbz@2x.png");
const xqsbz = ref("https://cos5.51tgqj.com/techming/img/xqsbz@2x.png");


const zsstt = ref("https://cos5.51tgqj.com/techming/img/zsstt@2x.png");
const gwzx = ref("https://cos5.51tgqj.com/techming/img/gwzx@2x.png");
const ycmf = ref("https://cos5.51tgqj.com/techming/img/ycmf@2x.png");
const whhm = ref("https://cos5.51tgqj.com/techming/img/whhm@2x.png");
const wds = ref("https://cos5.51tgqj.com/techming/img/wds@2x.png");
const hxd = ref("https://cos5.51tgqj.com/techming/img/hxd@2x.png");
const zxh = ref("https://cos5.51tgqj.com/techming/img/zxh@2x.png");
const xgts = ref("https://cos5.51tgqj.com/techming/img/xgts@2x.png");
const yzc = ref("https://cos5.51tgqj.com/techming/img/yzc@2x.png");
const ylyc = ref("https://cos5.51tgqj.com/techming/img/ylyc@2x.png");
const brlx = ref("https://cos5.51tgqj.com/techming/img/brlx@2x.png");
const bngx = ref("https://cos5.51tgqj.com/techming/img/bngx@2x.png");
const jyjg = ref("https://cos5.51tgqj.com/techming/img/jyjg@2x.png");
const bls = ref("https://cos5.51tgqj.com/techming/img/bls@2x.png");
const psdq = ref("https://cos5.51tgqj.com/techming/img/psdq@2x.png");
const hxq = ref("https://cos5.51tgqj.com/techming/img/hxq@2x.png");
const wzl = ref("https://cos5.51tgqj.com/techming/img/wzl@2x.png");
const lzso = ref("https://cos5.51tgqj.com/techming/img/lzso@2x.png");
const qsm = ref("https://cos5.51tgqj.com/techming/img/qsm@2x.png");



const towwqf = ref("https://cos5.51tgqj.com/techming/img/2wqf@2x.png");
const towwzg = ref("https://cos5.51tgqj.com/techming/img/2wzg@2x.png");
const towwws = ref("https://cos5.51tgqj.com/techming/img/2wws@2x.png");
const towwcy = ref("https://cos5.51tgqj.com/techming/img/2wcy@2x.png");
const towwjl = ref("https://cos5.51tgqj.com/techming/img/2wjl@2x.png");
const towwcf = ref("https://cos5.51tgqj.com/techming/img/2wcf@2x.png");





const hjt = ref("https://cos5.51tgqj.com/techming/img/hjt@2x.png");
const cyt = ref("https://cos5.51tgqj.com/techming/img/cyt@2x.png");
const wct = ref("https://cos5.51tgqj.com/techming/img/wct@2x.png");
const qct = ref("https://cos5.51tgqj.com/techming/img/qct@2x.png");
const sxt = ref("https://cos5.51tgqj.com/techming/img/sxt@2x.png");
const qft = ref("https://cos5.51tgqj.com/techming/img/qft@2x.png");








const zpht = ref("https://cos5.51tgqj.com/techming/img/zpht@2x.png");
const cyzph = ref("https://cos5.51tgqj.com/techming/img/cyzph@2x.png");
const sqzp = ref("https://cos5.51tgqj.com/techming/img/sqzp@2x.png");
const squfwr = ref("https://cos5.51tgqj.com/techming/img/squfwr@2x.png");
const nxsq = ref("https://cos5.51tgqj.com/techming/img/nxsq@2x.png");
const zbdgs = ref("https://cos5.51tgqj.com/techming/img/zbdgs@2x.png");
const zbdg = ref("https://cos5.51tgqj.com/techming/img/zbdg@2x.png");
const jyfw = ref("https://cos5.51tgqj.com/techming/img/jyfw@2x.png");
const gux = ref("https://cos5.51tgqj.com/techming/img/gux@2x.png");
const ywpx = ref("https://cos5.51tgqj.com/techming/img/ywpx@2x.png");
const zph = ref("https://cos5.51tgqj.com/techming/img/zph@2x.png");
const xljz = ref("https://cos5.51tgqj.com/techming/img/xljz@2x.png");


const zyjc = ref("https://cos5.51tgqj.com/techming/img/zyjc@2x.png");
const ldrs = ref("https://cos5.51tgqj.com/techming/img/ldrs@2x.png");
const zhzw = ref("https://cos5.51tgqj.com/techming/img/zhzw@2x.png");
const zhzwss = ref("https://cos5.51tgqj.com/techming/img/zhzwss@2x.png");
const whhms = ref("https://cos5.51tgqj.com/techming/img/whhms@2x.png");
const xj = ref("https://cos5.51tgqj.com/techming/img/xj@2x.png");
const isMode=ref(false)
onMounted(()=>{
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  console.log(userAgent)
  isMode.value = /android|iphone|ipad|ipod/i.test(userAgent);
})

const scrollToElement=(id)=>{
  let element=document.getElementById(id);
  element.scrollIntoView({behavior: "smooth"});
}

const wxClick=(index)=>{
  if (isMode.value){
    console.log('点击跳转')
    if (index==0){
      location.href='weixin://dl/business/?appid=wxe70e7398888d61ee&path=pages/recruitDeatil/recruitDeatil&query=QUERY&env_version=release';
    }else if(index==1){
      // location.href='';
    }else if(index==2){
      // location.href='';
    }else if(index==3){
      // location.href='';
    }else if(index==4){
      // location.href='';
    }else if(index==5){
      // location.href='';
    }
  }
}
</script>

<template>
  <div>
    <context-colors color="bg-[#F9F900]" class="flex justify-center text-center">
      <el-image :src="xmal" class="w-2/3"/>
    </context-colors>
    <context-colors color="bg-[#6D856D]" class=" text-white">
      <WidthFull>
        <div class="flex flex-col justify-center items-center" @click="scrollToElement('jyip')">
          <div class="">
            <el-image :src="jyIp" class="w-[8rem] md:w-[8rem] lg:w-[9rem]"/>
          </div>
          <text class="text-3xl md:text-3xl lg:text-[2rem] ">就业ip</text>
        </div>
        <div class="flex flex-col justify-center items-center ml-10" @click="scrollToElement('szxt')">
          <div class="">
            <el-image :src="szxt" class="w-[8rem] md:w-[8rem] lg:w-[9rem]"/>
          </div>
          <text class="text-3xl md:text-3xl lg:text-[2rem]">数智系统</text>
        </div>
        <div class="flex flex-col justify-center items-center ml-10" @click="scrollToElement('jyzd')">
          <div class="">
            <el-image :src="jyzd" class="w-[8rem] md:w-[8rem] lg:w-[9rem]"/>
          </div>
          <text class="text-3xl md:text-3xl lg:text-[2rem]">就业阵地</text>
        </div>
        <div class="flex flex-col justify-center items-center ml-10" @click="scrollToElement('jyhd')">
          <div class="">
            <el-image :src="jyhd" class="w-[8rem] md:w-[8rem] lg:w-[9rem]"/>
          </div>
          <text class="text-3xl md:text-3xl lg:text-[2rem]">就业活动</text>
        </div>
        <div class="flex flex-col justify-center items-center ml-10" @click="scrollToElement('sqjc')">
          <div class="">
            <el-image :src="zu12336" class="w-[8rem] md:w-[8rem] lg:w-[9rem]"/>
          </div>
          <text class="text-3xl md:text-3xl lg:text-[2rem]">社区就创</text>
        </div>
        <div class="flex flex-col justify-center items-center ml-10" @click="scrollToElement('jsfn')">
          <div class="">
            <el-image :src="JSFN" class="w-[8rem] md:w-[8rem] lg:w-[9rem]"/>
          </div>
          <text class="text-3xl md:text-3xl lg:text-[2rem]">技术赋能</text>
        </div>
      </WidthFull>
    </context-colors>
    <context>
      <titile-two-while title="就业ip" id="jyip"></titile-two-while>
      <text-context text="区域就业IP通过文化赋能与品牌聚合，将零散就业资源转化为特色产业标识，提升就业质量与稳定性。其价值在于：吸引人才集聚、塑造职业认同感、促进灵活就业创新，实现“在地化就业品牌化、就业服务产业化”的良性循环。"
                    color="text-[#ffffff]"/>
      <width-full class="items-end">
        <div class="w-[12%]">
          <el-image :src="tgbz" class="w-full"/>
        </div>
        <div class=" w-[12%]">
          <el-image :src="zgmbz" class="w-full"/>
        </div>
        <div class=" w-[12%]">
          <el-image :src="qfzpbz" class="w-full"/>
        </div>
        <div class=" w-[14%]">
          <el-image :src="mcfbz" class="w-full"/>
        </div>
        <div class=" w-[12%]">
          <el-image :src="jzjlbz" class="w-full"/>
        </div>
      </width-full>
      <width-full class="items-end">
        <div class=" w-[14%]">
          <el-image :src="gxzaxpbz" class="w-full"/>
        </div>
        <div class=" w-[14%]">
          <el-image :src="lqqbz" class="w-full"/>
        </div>
        <div class=" w-[14%]">
          <el-image :src="cypbz" class="w-full"/>
        </div>
        <div class=" w-[14%]">
          <el-image :src="wszpbz" class="w-full"/>
        </div>
        <div class=" w-[14%]">
          <el-image :src="xqsbz" class="w-full"/>
        </div>
      </width-full>
    </context>
    <context-colors color="bg-[#fff]">
      <titile-two-black title="品牌设计" id="ppsj"></titile-two-black>
      <width-full class="pt-2 items-end">
        <div class=" w-[14%]">
          <el-image :src="gwzx" class="w-full"/>
        </div>
        <div class=" w-[14%]">
          <el-image :src="ycmf" class="w-full"/>
        </div>
        <div class=" w-[14%]">
          <el-image :src="whhm" class="w-full"/>
        </div>
        <div class=" w-[14%]">
          <el-image :src="wds" class="w-full"/>
        </div>
        <div class=" w-[14%]">
          <el-image :src="hxd" class="w-full"/>
        </div>
      </width-full>

      <width-full class="pt-2 items-end">
        <div class=" w-[14%]">
          <el-image :src="zxh" class="w-full"/>
        </div>
        <div class=" w-[14%]">
          <el-image :src="xgts" class="w-full"/>
        </div>
        <div class=" w-[14%]">
          <el-image :src="yzc" class="w-full"/>
        </div>
        <div class=" w-[14%]">
          <el-image :src="ylyc" class="w-full"/>
        </div>
        <div class=" w-[14%]">
          <el-image :src="brlx" class="w-full"/>
        </div>
      </width-full>
      <width-full class="pt-2 items-end">
        <div class=" w-[18%]">
          <el-image :src="bngx" class="w-full"/>
        </div>
        <div class=" w-[18%]">
          <el-image :src="jyjg" class="w-full"/>
        </div>
        <div class=" w-[18%]">
          <el-image :src="bls" class="w-full"/>
        </div>
        <div class=" w-[18%]">
          <el-image :src="psdq" class="w-full"/>
        </div>
      </width-full>
      <width-full class="pt-2 items-end">
        <div class=" w-[18%]">
          <el-image :src="hxq" class="w-full"/>
        </div>
        <div class=" w-[18%]">
          <el-image :src="wzl" class="w-full"/>
        </div>
        <div class=" w-[18%]">
          <el-image :src="lzso" class="w-full"/>
        </div>
        <div class=" w-[18%]">
          <el-image :src="qsm" class="w-full"/>
        </div>
      </width-full>
    </context-colors>
    <context>
      <titile-two-while title="数智系统" id="szxt"></titile-two-while>
      <text-context
          color="text-[#ffffff]"
          text="基层平台以社区级数据感知、邻里信任背书、15分钟响应为核心优势，精准匹配非标岗位，提升45%中高龄就业率，实现政策精准触达与社区微经济孵化，解决大平台“三不”痛点：“看不见”“够不着”“管不好”，填补大平台服务盲区。"
          ></text-context>
    </context>
    <context-colors color="bg-[#ffffff]">
      <width-full>
        <div class=" w-[28%]">
          <el-image :src="towwqf" class="w-full"
          :preview-src-list="isMode?[]:[towwqf]" @click="wxClick(0)"/>
        </div>
        <div class=" w-[28%]">
          <el-image :src="towwzg" class="w-full"
                    show-progress
                    :preview-src-list="isMode?[]:[towwzg]" @click="wxClick(1)"/>
        </div>
        <div class=" w-[28%]">
          <el-image :src="towwws" class="w-full"
                    show-progress
                    :preview-src-list="isMode?[]:[towwws]" @click="wxClick(2)"/>
        </div>
      </width-full>
      <width-full class="mt-5 md:mt-5 lg:mt-10">
        <div class=" w-[28%]">
          <el-image :src="towwcy" class="w-full"
                    show-progress
                    :preview-src-list="isMode?[]:[towwcy]" @click="wxClick(3)"/>
        </div>
        <div class=" w-[28%]">
          <el-image :src="towwjl" class="w-full"
                    show-progress
                    :preview-src-list="isMode?[]:[towwjl]" @click="wxClick(4)"/>
        </div>
        <div class=" w-[28%]">
          <el-image :src="towwcf" class="w-full"
                    show-progress
                    :preview-src-list="isMode?[]:[towwcf]" @click="wxClick(5)"/>
        </div>
      </width-full>
    </context-colors>
    <context>
      <titile-two-while title="就业阵地" id="jyzd"></titile-two-while>
      <TextContext text="基层平台以社区级数据感知、邻里信任背书、15分钟响应为核心优势，精准匹配非标岗位，提升45%中高龄就业率，实现政策精准触达与社区微经济孵化，解决大平台“三不”痛点：“看不见”“够不着”“管不好”，填补大平台服务盲区。" color="text-[#ffffff]"/>
      <div class="flex max-w-full overflow-x-auto">
        <div class="lg:basis-1/2 p-2 lg:mr-4">
          <el-image :src="hjt" class="lg:h-[25rem] md:h-[10rem] rounded-lg"/>
        </div>
        <div class="lg:basis-1/2 p-2 lg:ml-4 text-right">
          <el-image :src="cyt" class="lg:h-[25rem] md:h-[10rem] rounded-lg"/>
        </div>
      </div>
        <div class="flex max-w-full overflow-x-auto">
        <div class="lg:basis-1/2 p-2 lg:mr-4">
          <el-image :src="wct" class="lg:h-[25rem] md:h-[10rem] rounded-lg"/>
        </div>
        <div class="lg:basis-1/2 p-2 lg:ml-4 text-right">
          <el-image :src="qct" class="lg:h-[25rem] md:h-[10rem] rounded-lg"/>
        </div>
        </div>
      <div class="flex max-w-full overflow-x-auto">
        <div class="lg:basis-1/2 p-2 lg:mr-4">
          <el-image :src="sxt" class="lg:h-[25rem] md:h-[10rem] rounded-lg"/>
        </div>
        <div class="lg:basis-1/2 p-2 lg:ml-4 text-right">
          <el-image :src="qft" class="lg:h-[25rem] md:h-[10rem] rounded-lg"/>
        </div>
      </div>
    </context>
    <context-colors color="bg-[#ffffff]" id="jyhd">
      <titile-two-black title="就业活动" id="sqjc"/>
      <width-full class="mt-4">
        <div class="w-1/5 text-center items-center">
          <el-image :src="zpht" class="w-full"/>
          <text-context text="服务双圈大型招聘会"></text-context>
        </div>
        <div class="w-1/5 text-center items-center">
          <el-image :src="cyzph" class="w-full"/>
          <text-context text="川渝两地联合招聘会"></text-context>
        </div>
        <div class="w-1/5 text-center items-center">
          <el-image :src="zbdg" class="w-full"/>
          <text-context text="直播带岗位"></text-context>
        </div>
        <div class="w-1/5 text-center items-center">
          <el-image :src="sqzp" class="w-full"/>
          <text-context text="社区招聘"></text-context>
        </div>
      </width-full>

      <width-full class="pt-2">
        <div class="w-1/5 text-center items-center">
          <el-image :src="squfwr" class="w-full"/>
          <text-context text="社区就业服务日"></text-context>
        </div>
        <div class="w-1/5 text-center items-center">
          <el-image :src="nxsq" class="w-full"/>
          <text-context text="暖心就业服务进社区"></text-context>
        </div>
        <div class="w-1/5 text-center items-center">
          <el-image :src="zbdgs" class="w-full"/>
          <text-context text="直播带货创业孵化"></text-context>
        </div>
        <div class="w-1/5 text-center items-center">
          <el-image :src="jyfw" class="w-full"/>
          <text-context text="渝见广货 就业服务"></text-context>
        </div>
      </width-full>
      <width-full class="pt-2">
        <div class="w-1/5 text-center items-center">
          <el-image :src="gux" class="w-full"/>
          <text-context text="小平故里企业职校行"></text-context>
        </div>
        <div class="w-1/5 text-center items-center">
          <el-image :src="ywpx" class="w-full"/>
          <text-context text="乡镇就业服务培训会"></text-context>
        </div>
        <div class="w-1/5 text-center items-center">
          <el-image :src="zph" class="w-full"/>
          <text-context text="主题招聘会"></text-context>
        </div>
        <div class="w-1/5 text-center items-center">
          <el-image :src="xljz" class="w-full"/>
          <text-context text="就业心理讲堂"></text-context>
        </div>
      </width-full>
    </context-colors>
    <context>
      <titile-two-while title="技术赋能" id="jsfn"/>
      <div class="flex flex-col md:flex-col lg:flex-row justify-center lg:justify-between md:justify-center items-center">
        <div class="md:w-3/4 p-5 lg:w-6/12">
          <el-image :src="zyjc" class="w-full"/>
        </div>
        <div class="md:w-full">
          <title-bold text="智慧集成社区噪音预警响应系统" color="text-[#ffffff]"/>
          <text-context text="社区广场舞噪音预警响应系统是一款创新的、智慧集成社区噪音预警响应系统，该系统融合先进硬件与智能软件，灵活设定广场舞噪音监控值，智能预警超标噪音，守护社区宁静。目前已布置多个点位，融入141社区自治平台，获得市领导及百姓认可。"
          color="text-[#ffffff]"/>
          <div class="w-full flex justify-between">
            <div>
              <text class="text-white text-3xl md:text-3xl lg:text-[1.8rem] ">安装运行情况</text>
              <div class="mt-4 flex flex-nowrap justify-between overflow-x-auto ">
                <div class="text-center content-center text-white">
                  <div class="flex items-end text-3xl md:text-3xl lg:text-[1.8rem]">
                    <div class= "">31</div>
                    <div class= "" >次</div>
                  </div>
                  <div class="rounded-full border px-2 ">触发一级预警</div>
                </div>
                <div class="text-center content-center ml-5 text-white" >
                  <div class="flex items-end text-3xl md:text-3xl lg:text-[1.8rem]">
                    <div class="">31</div>
                    <div class="">次</div>
                  </div>
                  <div class="rounded-full border px-2">触发一级预警</div>
                </div>
                <div class="text-center content-center ml-5 text-white">
                  <div class="flex items-end text-3xl md:text-3xl lg:text-[1.8rem]">
                    <div class="">0</div>
                    <div class="">次</div>
                  </div>
                  <div class="rounded-full border px-2">触发三级预警</div>
                </div>
              </div>
            </div>
            <div>
              <text class="text-white text-3xl md:text-3xl lg:text-[1.8rem]">居民对噪音的投诉</text>
              <div class="flex items-end">
                <div >
                  <el-image :src="xj" class="w-1/6 md:w-1/6 lg:w-full"/>
                </div>

                <div class="text-center content-center ml-5 text-white">
                  <div class="flex items-end text-3xl md:text-3xl lg:text-[1.8rem]">
                    <div class="">0</div>
                    <div class="">次</div>
                  </div>
                  <div class="text-white text-[1.3rem] md:text-[1.3rem] lg:text-[1.5rem]">
                    <div >安装前：月均噪音投诉5次</div>
                    <div >运行后：当月噪音投诉0次</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="w-full h-[0.08rem] my-4 bg-[#54C3F1] border-s"></div>
      <div class="flex flex-col md:flex-col lg:flex-row justify-center lg:justify-between md:justify-center items-center">
        <div class="md:w-3/4 p-5 lg:w-6/12">
          <el-image :src="ldrs" class="md:w-full" fit="contain"/>
        </div>
        <div class="md:w-full">
          <title-bold text="劳动人事争议一体化办案平台" color="text-[#ffffff]"/>
          <text-context text="川渝高竹新区劳动人事争议仲裁庭一体化办案平台定制开发项目，旨在打造高效、便捷的劳动仲裁服务模式。该平台通过跨域数据通办功能，打破川渝两地数据壁垒，实现案件信息实时共享与协同处理。同时，引入电子存证技术，确保证据安全、可靠、可追溯，提升办案公正性与透明度。借助信息化手段，群众办理劳动仲裁相关事务时，无需多地往返，跑动次数减少90%，真正实现“数据多跑路，群众少跑腿”，为川渝高竹新区劳动纠纷化解提供有力支撑，推动区域劳动关系和谐稳定发展。"
                        color="text-[#ffffff]"/>
        </div>
      </div>

      <div class="w-full h-[0.08rem] my-4 bg-[#54C3F1] border-s"></div>
      <div class="flex flex-col md:flex-col lg:flex-row justify-center lg:justify-between md:justify-center items-center">
        <div class="md:w-3/4 p-5 lg:w-8/12">
          <el-image :src="zhzw" class="md:w-full" fit="contain"/>
        </div>
        <div class="md:w-3/4 p-5 lg:w-4/12 items-end">
          <el-image :src="zhzwss" class="md:w-full" fit="contain"/>
        </div>
        <div class="md:w-full">
          <title-bold text="智慧政务会务系统" color="text-[#ffffff]"/>
          <text-context text="广安市公务服务中心政务会务系统定制开发项目，旨在通过数字化手段打造高效、智能的会务管理品牌。系统深度融入广安文化特色，彰显地域文化底蕴。采用无纸化协同办公模式，实现会议全流程线上流转，减少资源浪费。内置智能排期功能，自动优化会议安排，避免冲突。经测算，该系统可使会务效率提升200%，为政务工作注入强劲动力，助力政务服务迈向现代化、智能化。"
                        color="text-[#ffffff]"/>
        </div>
      </div>
      <div class="w-full h-[0.08rem] my-4 bg-[#54C3F1] border-s"></div>
      <div class="flex flex-col md:flex-col lg:flex-row justify-center lg:justify-between md:justify-center items-center">
        <div class="md:w-3/4 p-5 lg:w-6/12">
          <el-image :src="whhms" class="md:w-full" fit="contain"/>
        </div>
        <div class="md:w-full">
          <title-bold text="数字文化惠民点单系统" color="text-[#ffffff]"/>
          <text-context text="广安市文广旅局文化惠民系统定制开发项目，致力于打造独具特色的“文化下乡”品牌，深度展现广安丰富的文旅资源与地域文化魅力。通过百姓线上“点单”功能，精准对接群众文化需求，系统智慧化组织节目资源，智能排期安排文化下乡活动。艺术团体依据系统反馈，高效完成惠民演出任务，以惠民券形式回馈百姓，提升参与度与满意度。该系统将显著提升文化惠民活动的组织效率，效率提升300%，为广安文化繁荣注入强大动力，让文化成果更多惠及百姓。"
                        color="text-[#ffffff]"/>
        </div>
      </div>
    </context>
  </div>
</template>

<style scoped>

</style>
